var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4513 1.90332H21.8248L14.4547 10.3268L23.125 21.7893H16.3362L11.019 14.8374L4.93495 21.7893H1.55943L9.44243 12.7794L1.125 1.90332H8.08611L12.8924 8.25765L18.4513 1.90332ZM17.2673 19.7701H19.1366L7.07039 3.81645H5.06446L17.2673 19.7701Z",
    fill: "black"
  })));
};
export default SvgTwitter;